import styled from "styled-components";

import DropdownSingleSelectWithoutSearch from "shared/components/inputs/dropdown/DropdownSingleSelectWithoutSearch";
import FormInputWrapper from "shared/components/inputs/form/FormInputWrapper";
import { TEXT_VARIANT_STYLES } from "shared/components/data-display/text/Text";

export const StyledDropdown = styled(DropdownSingleSelectWithoutSearch)`
    width: 160px;
`;

export const StyledFormInputWrapper = styled(FormInputWrapper)`
    ${TEXT_VARIANT_STYLES.Headline_5};
`;
